export default __webpack_public_path__ + "static/media/Anoop.ea1bbde7.png";